import React, { useCallback, useEffect, useState } from "react";
import { showNotification } from "../../service/showNotification";
import styles from "./index.module.css";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { deleteContactOwner, getAllContactOwner } from "../../service/api";
import { ContactOwnerPopup } from "./ContactOwnerPopup";
import { tracker } from "../../service/mixpanel";
import { usePagination, useTable } from "../../context/TableContext.v2";
import { GlobalTable } from "../../helper/GlobalTable";

const columns = [
  { id: "userId", label: "User Id" },
  { id: "ownerName", label: "Contact Owner Name" },
  { id: "ownerEmail", label: "Contact Owner Email" },
  { id: "ownerPhone", label: "Contact Owner Phone" },
  { id: "ownerRole", label: "Contact Owner Role" },
  { id: "subOwnerName", label: "Sub Owner Name" },
  { id: "subOwnerEmail", label: "Sub Owner Email" },
  { id: "subOwnerPhone", label: "Sub Owner Phone" },
  { id: "subOwnerRole", label: "Sub Owner Role" },
  { id: "calendlyLink", label: "Calendly Link" },
  { id: "action", label: "Action" },
];

const ContactOwnerTable = ({ isRefetch }) => {
  const { itemsPerPage, currentPage, setTotalDocs } = usePagination();
  const { data, setData, refetch, setLoading } = useTable();
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [rowData, setRowData] = useState([]);

  const fetchContactOwner = useCallback(async () => {
    try {
      setLoading(true);
      const response = await getAllContactOwner(currentPage, itemsPerPage);
      setData(response.data?.docs || []);
      setTotalDocs(response.data?.totalDocs || 0);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [setData, setLoading, setTotalDocs, currentPage, itemsPerPage]);

  const handleDelete = async (id) => {
    tracker.contactOwner.deleteContactOwnerClick();
    try {
      await deleteContactOwner(id);
      showNotification("success", "Row deleted successfully");
      fetchContactOwner();
    } catch (error) {
      showNotification("error", "Something went wrong");
    }
  };

  const handleEdit = async (item) => {
    tracker.contactOwner.editContactOwnerClick();
    setRowData(item);
    setIsEditClicked(true);
  };

  const rows = data?.map((item) => ({
    ...item,
    userId: item?.userId || "-",
    ownerName: item?.ownerName || "-",
    ownerEmail: item?.ownerEmail || "-",
    ownerPhone: item?.ownerPhone || "-",
    ownerRole: item?.ownerRole || "-",
    subOwnerName: item?.subOwnerName || "-",
    subOwnerEmail: item?.subOwnerEmail || "-",
    subOwnerPhone: item?.subOwnerPhone || "-",
    subOwnerRole: item?.subOwnerRole || "-",
    calendlyLink: item?.calendlyLink || "-",
    action: (
      <div style={{ width: "3rem" }}>
        <FaEdit onClick={() => handleEdit(item)} className={styles.editIcon} />
        <MdDelete
          onClick={() => handleDelete(item?._id)}
          className={styles.deleteIcon}
        />
      </div>
    ),
  }));

  useEffect(() => {
    fetchContactOwner();
  }, [fetchContactOwner, isRefetch, refetch, currentPage, itemsPerPage]);

  return (
    <div className="scrollable-table-container2 mt-6 mx-2">
      <GlobalTable columns={columns} rows={rows || []} />
      {isEditClicked && (
        <ContactOwnerPopup
          rowData={rowData}
          setIsEditClicked={setIsEditClicked}
          fetchContactOwner={fetchContactOwner}
        />
      )}
    </div>
  );
};

export default ContactOwnerTable;
